
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Spots",
      function () {
        return require("private-next-pages/ShuffleMaps/Spots.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Spots"])
      });
    }
  